<template>
  <o-table :title="$t('core.data_changes')" url="/api/system/data_changes" ref="tableList" :enable-new="false"
           :enable-delete="false" :enable-edit="false" default-sort-by="id" default-sort-by-direction="desc">
    <template slot="filter">
      <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
        <o-filter-select :items="models" :title="$t('core.module')" column="revisionable_type"></o-filter-select>
        <o-filter-text :title="$t('core.column')" column="key"></o-filter-text>
        <o-filter-text :title="$t('core.old_value')" column="old_value"></o-filter-text>
        <o-filter-text :title="$t('core.new_value')" column="new_value"></o-filter-text>
        <o-filter-text :title="$t('sandoz.user')" column="user"></o-filter-text>
        <o-filter-text :title="$t('core.revision_id')" column="revision_id"></o-filter-text>
        <o-filter-text :title="$t('core.revisionable_id')" column="revisionable_id"></o-filter-text>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="revisionable_type">{{$t('core.table')}}</o-table-header>
      <o-table-header column="revisionable_type">{{$t('core.module')}}</o-table-header>
      <o-table-header column="key">{{$t('core.column')}}</o-table-header>
      <o-table-header column="old_value">{{$t('core.old_value')}}</o-table-header>
      <o-table-header column="new_value">{{$t('core.new_value')}}</o-table-header>
      <o-table-header column="revisionable_id">{{$t('core.revisionable_id')}}</o-table-header>
      <o-table-header column="revision_id">{{$t('core.revision_id')}}</o-table-header>
      <o-table-header :sortable="false">{{$t('core.user')}}</o-table-header>
      <o-table-header column="created_at">{{$t('core.date')}}</o-table-header>

    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.revisionable_type }}</td>
      <td>{{ props.item.revisionable_type_org }}</td>
      <td>{{ props.item.key }}</td>
      <td>{{ props.item.old_value }}</td>
      <td>{{ props.item.new_value }}</td>
      <td>{{ props.item.revisionable_id }}</td>
      <td>{{ props.item.revision_id }}</td>
      <td>{{ props.item.user ? props.item.user.name + ' (' + props.item.user.email + ')' : null }}</td>
      <td>{{ props.item.created_at | formatDatetime }}</td>
    </template>
  </o-table>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    models: [],
  }),
  mounted () {
    this.getDistinctModel()
  },
  methods: {
    getDistinctModel () {
      let $self = this;
      axios.get(`/api/system/data_changes/model`).then((response) => {
        response.data.models.forEach(function (model) {
          $self.models.push({
            value: model,
            text: model
          })
        })
      }).catch((error) => {
      })
    }
  }
}
</script>
